// src/utils/brandCustomization/defaultValues.js

/**
 * Textos por defecto para todos los email templates
 */
export const defaultEmailTexts = {
    ticketCreation: {
        greeting: '¡Hola {{nombre}}!',
        mainMessage: 'Tu tarjeta de fidelización ha sido creada exitosamente. Puedes verla en el siguiente enlace:',
        ctaText: 'Ver Mi Tarjeta',
        closingMessage: 'Si tienes alguna pregunta, no dudes en contactarnos.',
        footerText: 'Saludos,<br>Equipo {{brandName}}'
    },
    ticketResend: {
        greeting: '¡Hola {{nombre}}!',
        mainMessage: 'Aquí tienes el enlace a tu tarjeta de fidelización:',
        ctaText: 'Ver Mi Tarjeta',
        closingMessage: 'Si tienes alguna pregunta, no dudes en contactarnos.',
        footerText: 'Saludos,<br>Equipo {{brandName}}'
    },
    addFranchise: {
        greeting: '¡Hola {{nombre}}!',
        mainMessage: 'Te invitamos a unirte a {{tiendaNombre}} como franquiciado. Esta tienda forma parte de {{brandName}}. Por favor, haz clic en el siguiente enlace para completar tu registro:',
        ctaText: 'Unirse como Franquiciado',
        closingMessage: 'Si no solicitaste esta invitación, ignora este correo.',
        footerText: 'Saludos,<br><strong>Equipo {{tiendaNombre}}</strong>'
    },
    addWorker: {
        greeting: '¡Hola {{nombre}}!',
        mainMessage: 'Te invitamos a unirte a {{tiendaNombre}} como trabajador. Esta tienda forma parte de {{brandName}}. Por favor, haz clic en el siguiente enlace para completar tu registro:',
        ctaText: 'Unirse a {{tiendaNombre}}',
        closingMessage: 'Si no solicitaste esta invitación, ignora este correo.',
        footerText: 'Saludos,<br><strong>Equipo {{tiendaNombre}}</strong>'
    },
    winback: {
        greeting: '¡Hola {{nombre}}! 👋',
        mainMessage: 'Hace <strong>{{daysInactive}} días</strong> que no te vemos en <strong>{{brandName}}</strong>. ¡Te guardamos <strong>{{points}} puntos</strong> para tu próxima visita!',
        ctaText: 'Ver mi tarjeta de fidelización',
        closingMessage: '¡Esperamos verte pronto! 🎉',
        footerText: 'Si tienes alguna pregunta, no dudes en contactarnos.<br><br>Saludos,<br><b>Equipo {{brandName}}</b>'
    }
};

/**
 * Estilos por defecto para email templates
 */
export const defaultEmailStyles = {
    headerBackgroundColor: '#DC2626',
    headerTextColor: '#FFFFFF',
    bodyBackgroundColor: '#EFF6FF',
    bodyTextColor: '#1F2937',
    buttonBackgroundColor: '#3B82F6',
    buttonTextColor: '#FFFFFF',
    footerTextColor: '#6B7280',
    fontFamily: 'Arial, sans-serif',
    fontSize: '16px',
    borderRadius: '8px'
};

/**
 * Información de cada template
 */
export const emailTemplateInfo = {
    ticketCreation: {
        name: 'Email de Creación de Tarjeta',
        description: 'Email que se envía cuando se crea una nueva tarjeta de fidelización',
        icon: 'faEnvelope',
        color: 'blue'
    },
    ticketResend: {
        name: 'Email de Reenvío de Tarjeta',
        description: 'Email que se envía cuando se reenvía el enlace de la tarjeta',
        icon: 'faEnvelope',
        color: 'blue'
    },
    addFranchise: {
        name: 'Email de Invitación a Franquiciado',
        description: 'Email que se envía cuando se invita a un franquiciado a unirse a la marca',
        icon: 'faUserTie',
        color: 'indigo'
    },
    addWorker: {
        name: 'Email de Invitación a Trabajador',
        description: 'Email que se envía cuando se invita a un trabajador a unirse a la marca',
        icon: 'faUsers',
        color: 'green'
    },
    winback: {
        name: 'Email de WinBack (Recuperación de Clientes)',
        description: 'Email automático que se envía para recuperar clientes inactivos',
        icon: 'faUserClock',
        color: 'purple'
    }
};

/**
 * Variables disponibles por template
 */
export const emailTemplateVariables = {
    ticketCreation: [
        { name: '{{nombre}}', description: 'Nombre del destinatario' },
        { name: '{{link}}', description: 'Enlace de la tarjeta de fidelización' },
        { name: '{{brandName}}', description: 'Nombre de la marca' },
        { name: '{{brandSlogan}}', description: 'Eslogan de la marca' },
        { name: '{{supportEmail}}', description: 'Email de soporte' }
    ],
    ticketResend: [
        { name: '{{nombre}}', description: 'Nombre del destinatario' },
        { name: '{{link}}', description: 'Enlace de la tarjeta de fidelización' },
        { name: '{{brandName}}', description: 'Nombre de la marca' },
        { name: '{{brandSlogan}}', description: 'Eslogan de la marca' },
        { name: '{{supportEmail}}', description: 'Email de soporte' }
    ],
    addFranchise: [
        { name: '{{nombre}}', description: 'Nombre del destinatario' },
        { name: '{{link}}', description: 'Enlace de registro' },
        { name: '{{brandName}}', description: 'Nombre de la marca' },
        { name: '{{brandSlogan}}', description: 'Eslogan de la marca' },
        { name: '{{tiendaNombre}}', description: 'Nombre de la tienda' },
        { name: '{{supportEmail}}', description: 'Email de soporte' }
    ],
    addWorker: [
        { name: '{{nombre}}', description: 'Nombre del destinatario' },
        { name: '{{link}}', description: 'Enlace de registro' },
        { name: '{{brandName}}', description: 'Nombre de la marca' },
        { name: '{{brandSlogan}}', description: 'Eslogan de la marca' },
        { name: '{{tiendaNombre}}', description: 'Nombre de la tienda' },
        { name: '{{supportEmail}}', description: 'Email de soporte' }
    ],
    winback: [
        { name: '{{nombre}}', description: 'Nombre del cliente' },
        { name: '{{daysInactive}}', description: 'Días de inactividad' },
        { name: '{{points}}', description: 'Puntos acumulados' },
        { name: '{{link}}', description: 'Enlace de la tarjeta de fidelización' },
        { name: '{{brandName}}', description: 'Nombre de la marca' },
        { name: '{{brandSlogan}}', description: 'Eslogan de la marca' },
        { name: '{{supportEmail}}', description: 'Email de soporte' }
    ]
};

/**
 * Textos por defecto para páginas públicas
 */
export const defaultPublicPageTexts = {
    findTicket: {
        pageTitle: 'Buscar mi Tarjeta de Puntos',
        pageDescription: 'Ingresa tu correo electrónico para encontrar tu tarjeta digital de fidelización',
        emailLabel: 'Correo Electrónico',
        emailPlaceholder: 'tu@email.com',
        emailHelpText: 'El correo debe ser el mismo que usaste al registrarte',
        searchButtonText: 'Buscar mi Tarjeta',
        searchingButtonText: 'Buscando...',
        ticketNotFoundTitle: 'No tienes tarjeta en este comercio',
        ticketNotFoundMessage: 'No encontramos una tarjeta de puntos asociada a este correo electrónico.',
        joinClubQuestion: '¿Quieres unirte al club?',
        joinClubButtonText: 'Sí, unirme al club',
        cancelButtonText: 'Cancelar',
        helpSectionTitle: '¿Necesitas ayuda?',
        helpItem1: 'Asegúrate de usar el mismo correo electrónico con el que te registraste',
        helpItem2: 'El correo debe estar registrado en la marca',
        helpItem3: 'Si no encuentras tu tarjeta, puedes unirte al club de clientes',
        // Campos legacy (para compatibilidad)
        title: 'Encuentra tu Tarjeta',
        subtitle: 'Ingresa tu email para acceder a tu tarjeta de fidelización',
        inputPlaceholder: 'tu@email.com',
        buttonText: 'Buscar Mi Tarjeta',
        loadingText: 'Buscando...',
        notFoundTitle: 'Tarjeta no encontrada',
        notFoundMessage: 'No encontramos ninguna tarjeta asociada a este email',
        errorTitle: 'Error',
        errorMessage: 'Ocurrió un error al buscar tu tarjeta. Por favor, intenta nuevamente.'
    },
    productos: {
        title: 'Nuestros Productos',
        subtitle: 'Descubre nuestra selección de productos',
        categoriesTitle: 'Categorías',
        allCategoriesText: 'Todos',
        welcomeModalTitle: '¡Únete al Club!',
        welcomeModalDescription: 'Disfruta de beneficios exclusivos y ofertas especiales',
        benefit1Title: 'Descuentos Exclusivos',
        benefit1Description: 'Accede a ofertas especiales solo para miembros',
        benefit2Title: 'Regalo de Cumpleaños',
        benefit2Description: 'Sorpresas especiales en tu día',
        benefit3Title: 'Tarjeta Digital',
        benefit3Description: 'Acumula puntos en cada visita',
        joinButtonText: 'Unirme Ahora',
        maybeLaterButtonText: 'Quizás más tarde',
        floatingButtonText: 'Únete al Club',
        noProductsMessage: 'No se encontraron productos que coincidan con tu búsqueda.',
        searchPlaceholder: 'Buscar...'
    },
    qrRegister: {
        benefitsTitle: '¡Únete a nuestro club de clientes!',
        benefitsDescription: 'Disfruta de una experiencia personalizada y beneficios exclusivos:',
        benefit1Title: 'Beneficios Exclusivos',
        benefit1Description: 'Accede a ventajas especiales diseñadas para nuestros miembros',
        benefit2Title: 'Ofertas Personalizadas',
        benefit2Description: 'Recibe promociones adaptadas a tus preferencias',
        benefit3Title: 'Experiencias Únicas',
        benefit3Description: 'Sorpresas y eventos especiales para miembros',
        formTitle: 'Completa tu registro',
        personalInfoTitle: 'Información Personal',
        referralCodeTitle: '¿Tienes un código de referido?',
        referralCodePlaceholder: 'Ingresa tu código de referido (opcional)',
        geographicInfoTitle: 'Información Geográfica (Opcional)',
        submitButtonText: 'Unirme al Club de Clientes',
        termsText: 'Al registrarte, aceptas nuestros términos y condiciones y nuestra política de privacidad',
        successMessage: '¡Te has registrado correctamente!'
    }
};

/**
 * Textos por defecto para ticket/tarjeta
 */
export const defaultTicketTexts = {
    cardTitle: 'Tarjeta de Fidelización',
    pointsLabel: 'puntos',
    pointsLabelCustom: '',
    missingPointsText: 'Te faltan',
    pointsAvailableText: 'puntos disponibles',
    pointsToRedeemText: '¡Tienes {points} puntos para canjear!',
    accumulatePointsText: 'Acumula puntos para canjear premios',
    scanToAccumulateText: 'Escanea para acumular puntos',
    presentCodeText: 'Presenta este código en la tienda para acumular puntos automáticamente',
    memberLabel: 'Miembro',
    storeLabel: 'Tienda',
    userNameLabel: 'usuario',
    viewOnMapsText: 'Ver en Google Maps',
    shareCardText: 'Compartir Tarjeta',
    ticketGeneratedText: 'Ticket generado el',
    rewardsAvailableText: 'Premios disponibles para canjear',
    shareTitle: 'Mi Tarjeta de Fidelización',
    shareText: 'Tarjeta de {{brandName}}'
};

/**
 * Estilos por defecto para ticket/tarjeta
 */
export const defaultTicketStyles = {
    cardBackgroundColor: '#FFFFFF',
    headerBackgroundColor: '#3B82F6',
    headerTextColor: '#FFFFFF',
    textColor: '#111827',
    secondaryTextColor: '#6B7280',
    pointsColor: '#3B82F6',
    pointsLabelColor: '#6B7280',
    qrBackgroundColor: '#FFFFFF',
    qrBorderColor: '#E5E7EB',
    dividerColor: '#E5E7EB',
    iconColor: '#3B82F6',
    pageBackgroundColor: '#F9FAFB',
    fontFamily: 'sans-serif',
    fontSize: '16px',
    cardBorderRadius: '24px'
};

/**
 * Layouts disponibles
 */
export const availableLayouts = {
    ticket: [
        {
            id: 'wallet',
            name: 'Wallet',
            description: 'Diseño tipo wallet con patrón superior/inferior. Muestra sellos para tipo PUNTOS',
            preview: '💳'
        },
        {
            id: 'dark',
            name: 'Hero',
            description: 'Diseño con imagen hero. Muestra sellos para tipo PUNTOS',
            preview: '🌑'
        },
        {
            id: 'minimal',
            name: 'Moderno',
            description: 'Diseño moderno y elegante con gradientes. Muestra sellos para tipo PUNTOS',
            preview: '✨'
        }
    ],
    findTicket: [
        {
            id: 'centered',
            name: 'Centrado',
            description: 'Diseño centrado con header completo y tarjeta principal',
            preview: '🎯'
        },
        {
            id: 'minimal',
            name: 'Minimalista',
            description: 'Diseño limpio y minimalista sin elementos extra',
            preview: '✨'
        },
        {
            id: 'hero',
            name: 'Hero con Imagen',
            description: 'Header grande con imagen de fondo y contenido destacado',
            preview: '🖼️'
        }
    ],
    productos: [
        {
            id: 'grid',
            name: 'Grid de Productos',
            description: 'Vista en cuadrícula con categorías y productos',
            preview: '📦'
        },
        {
            id: 'list',
            name: 'Lista Vertical',
            description: 'Productos en lista vertical compacta',
            preview: '📋'
        },
        {
            id: 'cards',
            name: 'Cards Grandes',
            description: 'Tarjetas grandes con más información visual',
            preview: '🃏'
        }
    ],
    qrRegister: [
        {
            id: 'classic',
            name: 'Clásico',
            description: 'Diseño tradicional con header y formulario completo',
            preview: '📝'
        },
        {
            id: 'modern',
            name: 'Moderno',
            description: 'Diseño moderno con gradientes y animaciones',
            preview: '🚀'
        },
        {
            id: 'minimal',
            name: 'Minimalista',
            description: 'Diseño minimalista enfocado en el formulario',
            preview: '🎨'
        },
        {
            id: 'hero',
            name: 'Hero',
            description: 'Diseño impactante con imagen de fondo hero',
            preview: '🖼️'
        }
    ]
};

/**
 * Opciones de layout para ticket
 */
export const ticketLayoutOptions = [
    { key: 'showLogo', label: 'Mostrar Logo' },
    { key: 'showSlogan', label: 'Mostrar Slogan' },
    { key: 'showBrandName', label: 'Mostrar Nombre de Marca' },
    { key: 'showUserInfo', label: 'Mostrar Info de Usuario', layouts: ['dark'] },
    { key: 'showQRInHeader', label: 'Mostrar QR en Header', layouts: ['wallet'] },
    { key: 'showQRCode', label: 'Mostrar QR Code' },
    { key: 'showPointsSection', label: 'Mostrar Sección de Puntos', layouts: ['wallet'] },
    { key: 'showStars', label: 'Mostrar Estrellas', layouts: ['wallet'] },
    { key: 'showProgressBar', label: 'Mostrar Barra de Progreso', layouts: ['wallet'] },
    { key: 'showRewardsIndicator', label: 'Mostrar Indicador de Premios', layouts: ['wallet'] },
    { key: 'showDivider', label: 'Mostrar Línea Divisoria', layouts: ['wallet'] },
    { key: 'showClientInfo', label: 'Mostrar Info del Cliente', layouts: ['wallet'] },
    { key: 'showEmail', label: 'Mostrar Email', layouts: ['wallet'] },
    { key: 'showReferralCode', label: 'Mostrar Código Referido', layouts: ['wallet'] },
    { key: 'showStoreInfo', label: 'Mostrar Info de Tienda', layouts: ['wallet'] },
    { key: 'showMapsLink', label: 'Mostrar Enlace a Maps', layouts: ['wallet'] },
    { key: 'showFooter', label: 'Mostrar Footer', layouts: ['wallet'] },
    { key: 'showCreatedDate', label: 'Mostrar Fecha de Creación', layouts: ['wallet'] },
    { key: 'showShareButton', label: 'Mostrar Botón Compartir', layouts: ['wallet'] },
    { key: 'showWalletPattern', label: 'Mostrar Patrones Decorativos', layouts: ['wallet'] }
];

